import _classCallCheck from "/home/broford/website/ford-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/home/broford/website/ford-gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/broford/website/ford-gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/broford/website/ford-gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// tslint:disable:max-classes-per-file
import { EventType, PlatformEvent } from "./PlatformEvent";
export var OCSPEvent = /*#__PURE__*/function (_PlatformEvent) {
  _inherits(OCSPEvent, _PlatformEvent);

  var _super = _createSuper(OCSPEvent);

  function OCSPEvent(eventName, eventType, signature) {
    var _this;

    _classCallCheck(this, OCSPEvent);

    _this = _super.call(this, eventName, eventType);
    _this.privSignature = signature;
    return _this;
  }

  return OCSPEvent;
}(PlatformEvent);
export var OCSPMemoryCacheHitEvent = /*#__PURE__*/function (_OCSPEvent) {
  _inherits(OCSPMemoryCacheHitEvent, _OCSPEvent);

  var _super2 = _createSuper(OCSPMemoryCacheHitEvent);

  function OCSPMemoryCacheHitEvent(signature) {
    _classCallCheck(this, OCSPMemoryCacheHitEvent);

    return _super2.call(this, "OCSPMemoryCacheHitEvent", EventType.Debug, signature);
  }

  return OCSPMemoryCacheHitEvent;
}(OCSPEvent);
export var OCSPCacheMissEvent = /*#__PURE__*/function (_OCSPEvent2) {
  _inherits(OCSPCacheMissEvent, _OCSPEvent2);

  var _super3 = _createSuper(OCSPCacheMissEvent);

  function OCSPCacheMissEvent(signature) {
    _classCallCheck(this, OCSPCacheMissEvent);

    return _super3.call(this, "OCSPCacheMissEvent", EventType.Debug, signature);
  }

  return OCSPCacheMissEvent;
}(OCSPEvent);
export var OCSPDiskCacheHitEvent = /*#__PURE__*/function (_OCSPEvent3) {
  _inherits(OCSPDiskCacheHitEvent, _OCSPEvent3);

  var _super4 = _createSuper(OCSPDiskCacheHitEvent);

  function OCSPDiskCacheHitEvent(signature) {
    _classCallCheck(this, OCSPDiskCacheHitEvent);

    return _super4.call(this, "OCSPDiskCacheHitEvent", EventType.Debug, signature);
  }

  return OCSPDiskCacheHitEvent;
}(OCSPEvent);
export var OCSPCacheUpdateNeededEvent = /*#__PURE__*/function (_OCSPEvent4) {
  _inherits(OCSPCacheUpdateNeededEvent, _OCSPEvent4);

  var _super5 = _createSuper(OCSPCacheUpdateNeededEvent);

  function OCSPCacheUpdateNeededEvent(signature) {
    _classCallCheck(this, OCSPCacheUpdateNeededEvent);

    return _super5.call(this, "OCSPCacheUpdateNeededEvent", EventType.Debug, signature);
  }

  return OCSPCacheUpdateNeededEvent;
}(OCSPEvent);
export var OCSPMemoryCacheStoreEvent = /*#__PURE__*/function (_OCSPEvent5) {
  _inherits(OCSPMemoryCacheStoreEvent, _OCSPEvent5);

  var _super6 = _createSuper(OCSPMemoryCacheStoreEvent);

  function OCSPMemoryCacheStoreEvent(signature) {
    _classCallCheck(this, OCSPMemoryCacheStoreEvent);

    return _super6.call(this, "OCSPMemoryCacheStoreEvent", EventType.Debug, signature);
  }

  return OCSPMemoryCacheStoreEvent;
}(OCSPEvent);
export var OCSPDiskCacheStoreEvent = /*#__PURE__*/function (_OCSPEvent6) {
  _inherits(OCSPDiskCacheStoreEvent, _OCSPEvent6);

  var _super7 = _createSuper(OCSPDiskCacheStoreEvent);

  function OCSPDiskCacheStoreEvent(signature) {
    _classCallCheck(this, OCSPDiskCacheStoreEvent);

    return _super7.call(this, "OCSPDiskCacheStoreEvent", EventType.Debug, signature);
  }

  return OCSPDiskCacheStoreEvent;
}(OCSPEvent);
export var OCSPCacheUpdateCompleteEvent = /*#__PURE__*/function (_OCSPEvent7) {
  _inherits(OCSPCacheUpdateCompleteEvent, _OCSPEvent7);

  var _super8 = _createSuper(OCSPCacheUpdateCompleteEvent);

  function OCSPCacheUpdateCompleteEvent(signature) {
    _classCallCheck(this, OCSPCacheUpdateCompleteEvent);

    return _super8.call(this, "OCSPCacheUpdateCompleteEvent", EventType.Debug, signature);
  }

  return OCSPCacheUpdateCompleteEvent;
}(OCSPEvent);
export var OCSPStapleReceivedEvent = /*#__PURE__*/function (_OCSPEvent8) {
  _inherits(OCSPStapleReceivedEvent, _OCSPEvent8);

  var _super9 = _createSuper(OCSPStapleReceivedEvent);

  function OCSPStapleReceivedEvent() {
    _classCallCheck(this, OCSPStapleReceivedEvent);

    return _super9.call(this, "OCSPStapleReceivedEvent", EventType.Debug, "");
  }

  return OCSPStapleReceivedEvent;
}(OCSPEvent);
export var OCSPWSUpgradeStartedEvent = /*#__PURE__*/function (_OCSPEvent9) {
  _inherits(OCSPWSUpgradeStartedEvent, _OCSPEvent9);

  var _super10 = _createSuper(OCSPWSUpgradeStartedEvent);

  function OCSPWSUpgradeStartedEvent(serialNumber) {
    _classCallCheck(this, OCSPWSUpgradeStartedEvent);

    return _super10.call(this, "OCSPWSUpgradeStartedEvent", EventType.Debug, serialNumber);
  }

  return OCSPWSUpgradeStartedEvent;
}(OCSPEvent);
export var OCSPCacheEntryExpiredEvent = /*#__PURE__*/function (_OCSPEvent10) {
  _inherits(OCSPCacheEntryExpiredEvent, _OCSPEvent10);

  var _super11 = _createSuper(OCSPCacheEntryExpiredEvent);

  function OCSPCacheEntryExpiredEvent(serialNumber, expireTime) {
    var _this2;

    _classCallCheck(this, OCSPCacheEntryExpiredEvent);

    _this2 = _super11.call(this, "OCSPCacheEntryExpiredEvent", EventType.Debug, serialNumber);
    _this2.privExpireTime = expireTime;
    return _this2;
  }

  return OCSPCacheEntryExpiredEvent;
}(OCSPEvent);
export var OCSPCacheEntryNeedsRefreshEvent = /*#__PURE__*/function (_OCSPEvent11) {
  _inherits(OCSPCacheEntryNeedsRefreshEvent, _OCSPEvent11);

  var _super12 = _createSuper(OCSPCacheEntryNeedsRefreshEvent);

  function OCSPCacheEntryNeedsRefreshEvent(serialNumber, startTime, expireTime) {
    var _this3;

    _classCallCheck(this, OCSPCacheEntryNeedsRefreshEvent);

    _this3 = _super12.call(this, "OCSPCacheEntryNeedsRefreshEvent", EventType.Debug, serialNumber);
    _this3.privExpireTime = expireTime;
    _this3.privStartTime = startTime;
    return _this3;
  }

  return OCSPCacheEntryNeedsRefreshEvent;
}(OCSPEvent);
export var OCSPCacheHitEvent = /*#__PURE__*/function (_OCSPEvent12) {
  _inherits(OCSPCacheHitEvent, _OCSPEvent12);

  var _super13 = _createSuper(OCSPCacheHitEvent);

  function OCSPCacheHitEvent(serialNumber, startTime, expireTime) {
    var _this4;

    _classCallCheck(this, OCSPCacheHitEvent);

    _this4 = _super13.call(this, "OCSPCacheHitEvent", EventType.Debug, serialNumber);
    _this4.privExpireTime = expireTime;
    _this4.privExpireTimeString = new Date(expireTime).toLocaleDateString();
    _this4.privStartTime = startTime;
    _this4.privStartTimeString = new Date(startTime).toLocaleTimeString();
    return _this4;
  }

  return OCSPCacheHitEvent;
}(OCSPEvent);
export var OCSPVerificationFailedEvent = /*#__PURE__*/function (_OCSPEvent13) {
  _inherits(OCSPVerificationFailedEvent, _OCSPEvent13);

  var _super14 = _createSuper(OCSPVerificationFailedEvent);

  function OCSPVerificationFailedEvent(serialNumber, error) {
    var _this5;

    _classCallCheck(this, OCSPVerificationFailedEvent);

    _this5 = _super14.call(this, "OCSPVerificationFailedEvent", EventType.Debug, serialNumber);
    _this5.privError = error;
    return _this5;
  }

  return OCSPVerificationFailedEvent;
}(OCSPEvent);
export var OCSPCacheFetchErrorEvent = /*#__PURE__*/function (_OCSPEvent14) {
  _inherits(OCSPCacheFetchErrorEvent, _OCSPEvent14);

  var _super15 = _createSuper(OCSPCacheFetchErrorEvent);

  function OCSPCacheFetchErrorEvent(serialNumber, error) {
    var _this6;

    _classCallCheck(this, OCSPCacheFetchErrorEvent);

    _this6 = _super15.call(this, "OCSPCacheFetchErrorEvent", EventType.Debug, serialNumber);
    _this6.privError = error;
    return _this6;
  }

  return OCSPCacheFetchErrorEvent;
}(OCSPEvent);
export var OCSPResponseRetrievedEvent = /*#__PURE__*/function (_OCSPEvent15) {
  _inherits(OCSPResponseRetrievedEvent, _OCSPEvent15);

  var _super16 = _createSuper(OCSPResponseRetrievedEvent);

  function OCSPResponseRetrievedEvent(serialNumber) {
    _classCallCheck(this, OCSPResponseRetrievedEvent);

    return _super16.call(this, "OCSPResponseRetrievedEvent", EventType.Debug, serialNumber);
  }

  return OCSPResponseRetrievedEvent;
}(OCSPEvent);
export var OCSPCacheUpdateErrorEvent = /*#__PURE__*/function (_OCSPEvent16) {
  _inherits(OCSPCacheUpdateErrorEvent, _OCSPEvent16);

  var _super17 = _createSuper(OCSPCacheUpdateErrorEvent);

  function OCSPCacheUpdateErrorEvent(serialNumber, error) {
    var _this7;

    _classCallCheck(this, OCSPCacheUpdateErrorEvent);

    _this7 = _super17.call(this, "OCSPCacheUpdateErrorEvent", EventType.Debug, serialNumber);
    _this7.privError = error;
    return _this7;
  }

  return OCSPCacheUpdateErrorEvent;
}(OCSPEvent);